/* eslint-disable import/prefer-default-export */
export const PATH = {
  OTP: '/otp',
  DASHBOARD: '/applicantslist',
};

export const APP_STATUS = {
  ONGOING: 'NW-MAR-ON-BOARD',
  COMPLETED: 'NW-MAR-COMPLETE',
  CANCELLED: 'NW-MAR-ON-CANCEL',
};

export const APP_STATUS_MAPPING = {
  'NW-MAR-ON-BOARD': 'nw.markaz.middle_office.onboarding',
  'NW-MAR-COMPLETE': 'nw.markaz.middle_office.complete',
  'NW-MAR-ON-CANCEL': 'nw.markaz.middle_office.cancel',
};

export const ONBOARDING_CATEGORY_MAPPING = {
  'NW-MAR-CLA-RET': 'clientDetails.classification.retail',
  'NW-MAR-CLA-QUA': 'clientDetails.classification.qualified',
  'NW-MAR-CLA-IMA-RET': 'clientDetails.classification.imarkaz.retail',
  'NW-MAR-CLA-IMA-RET-POA': 'clientDetails.classification.imarkaz.retail.poa',
  'NW-MAR-CLA-IMA-RET-MIN': 'clientDetails.classification.imarkaz.retail.minor',
  'NW-MAR-CLA-IMA-QUA': 'clientDetails.classification.imarkaz.qualified',
  'NW-MAR-CLA-IMA-QUA-POA': 'clientDetails.classification.imarkaz.qualified.poa',
  'NW-MAR-CLA-IMA-QUA-MIN': 'clientDetails.classification.imarkaz.qualified.minor',
  'NW-MAR-CLA-COB-RET': 'clientDetails.classification.cob.retail',
  'NW-MAR-CLA-COB-RET-POA': 'clientDetails.classification.cob.retail.poa',
  'NW-MAR-CLA-COB-RET-MIN': 'clientDetails.classification.cob.retail.minor',
  'NW-MAR-CLA-COB-QUA': 'clientDetails.classification.cob.qualified',
  'NW-MAR-CLA-COB-QUA-POA': 'clientDetails.classification.cob.qualified.poa',
  'NW-MAR-CLA-COB-QUA-MIN': 'clientDetails.classification.cob.qualified.minor',
};

export const CLIENT_DATA = {
  EMAIL: 'email',
  TOKEN: 'token',
  PHONE: 'phone',
  SESSION: 'session',
};

const basePdfUrl = '/markaz/pdf?phone={phone}&type=';
export const PDF_DOWNLOAD_URL = {
  CRM: {
    url: `${basePdfUrl}crm{lang}`,
    name: 'CRM',
  },
  FATCA: {
    url: `${basePdfUrl}fatca{lang}`,
    name: 'FATCA',
  },
  CRS: {
    url: `${basePdfUrl}crs{lang}`,
    name: 'CRS',
  },

  NDPF: {
    url: `${basePdfUrl}ndpf`,
    name: 'Portfolio Agreement and Attachments',
  },
  SIMULATION: {
    name: 'iMarkaz PDF Simulation',
  },
  MFT: {
    url: `${basePdfUrl}mft`,
    name: 'Mutual Fund Subscription',
  },
};

const baseImgUrl = '/markaz/applicant/image?phone={phone}&type=';
export const IMG_DOWNLOAD_URL = {
  CIVIL_ID_FRONT: {
    url: `${baseImgUrl}civilIdFront`,
    name: 'Civil ID Front',
  },
  CIVIL_ID_BACK: {
    url: `${baseImgUrl}civilIdBack`,
    name: 'Civil ID Back',
  },
  PASSPORT: {
    url: `${baseImgUrl}passport`,
    name: 'Passport',
  },
  SELFIE: {
    url: `${baseImgUrl}selfie`,
    name: 'Selfie',
  },
  PROOF_OF_TRANSFER: {
    url: `${baseImgUrl}proofOfTransfer`,
    name: 'Proof of transfer',
  },
};

export const EXCEL_DOWNLOAD = {
  url: '/markaz/applicant/excel?phone={phone}',
  name: 'Applicant Details',
};

export const CONST_RETAIL_APPLICANT = {
  SELECT_BOX: {
    APPROVE: 'approve',
    REWORK: 'rework',
  },
  DROPDOWN: {
    ONGOING: 'ongoing',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
  },
  STATUS: {
    PARTIAL: 'partial',
    COMPLETE: 'complete',
    APPROVED: 'approved',
    REWORKED: 'rework',
    AGREEMENT_GENERATED: 'agreement generated',
    AGREEMENT_SIGNED: 'agreement signed',
    UNDER_REVIEW: 'under review',
    AGREEMENT_READY: 'agreement ready',
    PREPARING_AGREEMENT: 'preparing agreement',
    WAITING_FOR_CLIENT_TO_SIGN: 'waiting for client to sign',
  },
};

export const CIVIL_INFO = {
  PASSPORT: 'passport',
  CIVIL_ID_FRONT: 'civilIdFront',
  CIVIL_ID_BACK: 'civilIdBack',
  SELFIE: 'selfie',
};

export const FILE_ACTION = {
  REPLACE: 'REPLACE',
  DELETE: 'DELETE',
};
